import React from "react";
import PropTypes from "prop-types";
import classname from "classnames";
import Button from "../components/Button";
import StepHeader from "../components/StepHeader";
import Animate from "../Animate";

import { ContentWithVarsShape } from "../utils/types";

export default function Message({
  id,
  title = "",
  description = "",
  htmlContent = "",
  imageSrc = "",
  submitLabel = "",
  onSubmit,
  variables,
  emptyVariableFormatter,
}) {
  const classGrid = classname("grid", {
    "grid--center": imageSrc === undefined,
  });

  return (
    <Animate>
      <div className={classGrid}>
        <div className="container">
          <StepHeader
            title={title}
            description={description}
            imageSrc={imageSrc}
            htmlContent={htmlContent}
            variables={variables}
            emptyVariableFormatter={emptyVariableFormatter}
          />

          {submitLabel && (
            <Button label={submitLabel} onClick={handleSubmit} sticky={true} />
          )}
        </div>
      </div>
    </Animate>
  );

  function handleSubmit(_event) {
    onSubmit(null, id);
  }
}

Message.propTypes = {
  id: PropTypes.string.isRequired,
  title: ContentWithVarsShape,
  description: ContentWithVarsShape,
  htmlContent: PropTypes.string,
  imageSrc: PropTypes.string,
  submitLabel: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  variables: PropTypes.object.isRequired,
  emptyVariableFormatter: PropTypes.func,
};
